<template>
  <div>
    <h2>Фактическая оплата</h2>
    <br>
    <div class="row g-3">

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingMonth" class="form-label col-md-3">Расчетный месяц</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min='1' max='12' step="1" class="form-control" id="accountingMonth" v-model="searchParam.accountingMonth">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="accountingYear" class="form-label col-md-3">Расчетный год</label>
          <div class="col-md-9">
            <div class="input-group">
              <input type="number" min='2024' step="1" class="form-control" id="accountingYear" v-model="searchParam.accountingYear">
            </div>
          </div>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="binList" class="form-label col-md-3">Список бинов:</label>
          <textarea id="binList" cols="15" rows="5" class="form-control" v-model="searchParam.binList"
                    required
                    placeholder="1234567, 1234567, ...
или
1234567
1234567
..."></textarea>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="binList" class="form-label col-md-3">Список LMS ID:</label>
          <textarea id="binList" cols="15" rows="5" class="form-control" v-model="searchParam.lmsIdList"
                    required
                    placeholder="1-1-1, 1-1-2, ...
или
1-1-1
1-1-2
..."></textarea>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="actNumberList" class="form-label col-md-3">Список Акт номеров:</label>
          <textarea id="actNumberList" cols="15" rows="5" class="form-control" v-model="searchParam.actNumberList"
                    required
                    placeholder="250022/00/625, 250022/00/635, ...
или
250022/00/625
250022/00/635
..."></textarea>
        </div>
      </div>

      <div class="row col-md-7">
        <div class="el-input-group">
          <label for="katoCode" class="form-label col-md-3">Населенный пункт</label>
          <div class="col-md-9">
            <div class="input-group">
              <multiselect
                  v-model="kato"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  track-by="code"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-7">
        <div class="el-input-group">
          <button class="btn btn-primary" @click="fetchKindergartenFactPayment(true)" :disabled="fullPaidAmountForm.isLoading">{{ fullPaidAmountForm.isLoading ? 'Загрузка...' : 'Поиск'  }}</button>
          <button class="btn btn-warning" @click="clearSearchParam()" :disabled="fullPaidAmountForm.isLoading">Сбросить фильтр</button>
          <button v-if="pageResponse?.totalElements && pageResponse?.totalElements > 0" class="btn btn-info" @click="showFullPaidModel" :disabled="fullPaidAmountForm.isLoading">Полная выплата по выбранным ДО</button>
        </div>
      </div>

      <div class="page-content-info d-flex align-items-center justify-content-end">
        <button :disabled = "(items?.length === 0) && fullPaidAmountForm.isLoading"  class="btn btn-info align-items-center justify-content-end" @click="downloadFactPaymentReport()">Выгрузить
          результат по фильтру
        </button>
        <button class="btn btn-success align-items-center justify-content-end" @click="showUploadModal = true">Загрузить номера выплат</button>
      </div>

    </div>

    <b-pagination v-model="currentPage" :total-rows="pageResponse?.totalElements" :per-page="searchParam.perPage"></b-pagination>

    <b-table-simple bordered="">
      <b-thead head-variant="light">
        <b-tr>
          <b-th>БИН</b-th>
          <b-th>LMS ID</b-th>
          <b-th>Населенный пункт</b-th>
          <b-th>Расчетный месяц и год</b-th>
          <b-th>Общая сумма для выплаты</b-th>
          <b-th>Выплачено</b-th>
          <b-th>Осталось выплатить</b-th>
          <b-th>#</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(item, index) in items" :key="index">
          <b-td class="default" :class="[paidAmountForm[item.id].valueId !== null && item.id === paidAmountForm[item.id].valueId ? 'success' : '']">{{ item.bin }}</b-td>
          <b-td class="default" :class="[paidAmountForm[item.id].valueId !== null && item.id === paidAmountForm[item.id].valueId ? 'success' : '']">{{ item.lmsId }}</b-td>
          <b-td class="default" :class="[paidAmountForm[item.id].valueId !== null && item.id === paidAmountForm[item.id].valueId ? 'success' : '']">{{ item.lmsSystem.kato.nameRu }}</b-td>
          <b-td class="default" :class="[paidAmountForm[item.id].valueId !== null && item.id === paidAmountForm[item.id].valueId ? 'success' : '']">{{ item.accountingMonth }}.{{ item.accountingYear }}</b-td>
          <b-td class="default" :class="[paidAmountForm[item.id].valueId !== null && item.id === paidAmountForm[item.id].valueId ? 'success' : '']">{{ item.totalSum }}</b-td>
          <b-td class="default" :class="[paidAmountForm[item.id].valueId !== null && item.id === paidAmountForm[item.id].valueId ? 'success' : '']">{{ item.totalPaidAmount }} <span v-if="item.totalPaidAmount == item.totalSum">✅</span></b-td>
          <b-td class="default" :class="[paidAmountForm[item.id].valueId !== null && item.id === paidAmountForm[item.id].valueId ? 'success' : '']">{{ item.totalReminderAmount }}</b-td>
          <b-td style="width: 15%;"
              class="default" :class="[paidAmountForm[item.id].valueId !== null && item.id === paidAmountForm[item.id].valueId ? 'success' : '']"
          >
            <div v-for="(paidAmountData, index2) in item.kindergartenPaidAmounts" :key="index2">
              <div>
                <span>Дата: {{ formatDate(paidAmountData.paidDate) }}</span><br>
                <span>Сумма: {{ paidAmountData.paidAmount }} тг.</span><br>
                <span>Номер: {{ paidAmountData.paymentNumber }}</span><br>
                <span>----------------</span><br>
              </div>
            </div>
            <div v-if="item.totalReminderAmount && item.totalReminderAmount > 0">
              <button v-if="!paidAmountForm[item.id].showForm" class="btn btn-info" @click="showPaidForm(item.id)">Добавить выплату</button>
              <div v-else>
                <div>
                  <form class="row" @submit.prevent="handleSubmit(paidAmountForm[item.id].data)">
                    <div class="row col-md-12">
                      <div class="el-input-group">
                        <div class="input-group">
                          <input type="date" class="form-control" v-model="paidAmountForm[item.id].data.paidDate" required>
                        </div>
                      </div>
                    </div>
                    <div class="row col-md-12">
                      <div class="el-input-group">
                        <div class="input-group">
                          <input type="number" step="0.01" min="0.01" class="form-control" v-model="paidAmountForm[item.id].data.paidAmount" required>
                        </div>
                      </div>
                    </div>
                    <div class="row col-md-12">
                      <div class="el-input-group">
                        <div class="input-group">
                          <input type="text" class="form-control" v-model="paidAmountForm[item.id].data.paymentNumber" placeholder="Номер выплаты">
                        </div>
                      </div>
                    </div>
                    <div class="row col-md-12">
                      <button type="submit" class="btn btn-success" :class="{disabled: paidAmountForm[item.id].loading}">Сохранить</button>
                    </div>
                    <div class="row col-md-12">
                      <button type="button" class="btn btn-warning" @click="closePaidForm(item.id)" :class="{disabled: paidAmountForm[item.id].loading}">Отмена</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>

    <b-modal v-model="fullPaidAmountForm.isShowModel" title="Полная выплата по выбранным ДО" hide-footer>
      <form @submit.prevent="submitSetFullPaidAmount">
        <div class="md-3">
          <label class="form-label">Расчетный месяц</label>
          <input type="number" class="form-control" disabled :value="searchParam.accountingMonth">
        </div>
        <div class="md-3">
          <label class="form-label">Расчетный год</label>
          <input type="number" class="form-control" disabled :value="searchParam.accountingYear">
        </div>
        <div v-if="searchParam.lmsIdList != ''" class="md-3">
          <label class="form-label">Список БИНов ДО</label>
          <textarea cols="15" rows="5" class="form-control" disabled :value="searchParam.binList"></textarea>
        </div>
        <div v-if="searchParam.lmsIdList != ''" class="md-3">
          <label class="form-label">Список LMS ID</label>
          <textarea cols="15" rows="5" class="form-control" disabled :value="searchParam.lmsIdList"></textarea>
        </div>
        <div v-if="kato != null" class="md-3">
          <label class="form-label">Населенный пункт</label>
          <input type="text" class="form-control" disabled :value="formattedKatoLabel(kato)">
        </div>
        <div class="md-3">
          <label for="paidDate" class="form-label">Дата выплаты</label>
          <input type="date" class="form-control" v-model="fullPaidAmountForm.paidDate" required>
        </div>
        <div class="md-3">
          <button type="submit" class="btn btn-success" :disabled="fullPaidAmountForm.isLoading">{{ fullPaidAmountForm.isLoading ? "Загрузка" : "Сохранить" }}</button>
          <button type="button" class="btn btn-warning" :disabled="fullPaidAmountForm.isLoading" @click="closeFullPaidModel">Закрыть</button>
        </div>
      </form>
    </b-modal>

    <div v-if="showUploadModal" class="modal">
      <div class="modal-content">
        <h4>Выберите .xlsx файл для загрузки Номера платежей</h4>
        <form @submit.prevent="handleUploadSubmit">
          <div class="form-group">
            <label for="timesheetFile" class="form-label">
              Выберите .xlsx файл
            </label>
            <input type="file" id="timesheetFile" class="form-control" required accept=".xlsx" @change="handleFileUpload">
          </div>
          <div class="form-group">
            <button type="submit" class="submit-btn" :disable="isLoading">
              {{ isLoading ? 'Загружается...' : 'Загрузить' }}
            </button>
          </div>
        </form>
        <button class="close-modal-btn" @click="showUploadModal = false">Закрыть</button>
      </div>
    </div>

  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, reactive, ref, watch} from "vue";
import Multiselect from "vue-multiselect";
import {Kato, KindergartenPaidAmount} from "@/types/kindergarten";
import cacheService from "@/services/cacheService";
import {KindergartenCalculationReport} from "@/types/report";
import {PageResponse} from "@/types/pageResponse";
import {SearchParam} from "@/types/searchParam";
import {
  addFullKindergartenPaidAmount,
  addKindergartenPaidAmount,
  findKindergartenPaidAmount, uploadKindergartenPaidAmountXlsx
} from "@/services/kindergartenService";
import {getGeneratedFactPaymentReport} from "@/services/reportService";
import {ElMessage} from "element-plus";

export default defineComponent(
    {
      name: 'FactPayment',
      components: {Multiselect},
      setup() {
        const uploadedFile = ref<any>();
        const showUploadModal = ref(false);
        const currentPage = ref(1);
        const page = ref(1);
        const searchParam = reactive({
          perPage: 10,
          page: 1,
          binList: "",
          lmsIdList: "",
          actNumberList: "",
          katoCode: "",
          accountingMonth: new Date().getMonth() + 1,
          accountingYear: new Date().getFullYear(),
        });
        const kato = ref<Kato | null>(null);
        const katoList = ref<Kato[]>([]);
        const isLoading = ref(false);
        const pageResponse = ref<PageResponse<KindergartenCalculationReport>>();
        const items = ref<KindergartenCalculationReport[]>();
        interface PaidAmountFormEntry {
          showForm: boolean;
          loading: boolean;
          valueId: number | null;
          data: KindergartenPaidAmount;
        }
        const paidAmountForm: { [key: number]: PaidAmountFormEntry } = reactive({});
        let fullPaidAmountForm = reactive({
          isLoading: false,
          isShowModel: false,
          paidDate: new Date()
        });


        onMounted(() => {
          fetchCachedData();
        });

        const fetchCachedData = async () => {
          katoList.value = await cacheService.useKatoStore().fetchKato();
        };

        const formattedKatoLabel = (item: any) => {
          return `${item.code} | ${item.nameRu}`;
        };

        const clearSearchParam = () => {
          kato.value = null;
          searchParam.accountingMonth = new Date().getMonth() + 1;
          searchParam.accountingYear = new Date().getFullYear();
          searchParam.binList = "";
          searchParam.lmsIdList = "";
          searchParam.katoCode = "";

          fullPaidAmountForm.paidDate = new Date();
        }

        const searchParamSerializer = (isPageDefault: boolean = false) => {
          const searchParamResponse = new SearchParam(searchParam.perPage, 0, searchParam, reactive({}));
          if (isPageDefault) {
            searchParamResponse.partNumber = 0;
            currentPage.value = 1;
          }
          searchParamResponse.partNumber = currentPage.value;
          if (kato.value) {
            searchParamResponse.filter.katoCode = kato.value?.code;
          }
          return searchParamResponse;
        }

        const fetchKindergartenFactPayment = async (isPageDefault: boolean = false) => {
          try {
            fullPaidAmountForm.isLoading = true;
            const searchParamResponse = searchParamSerializer(isPageDefault);
            pageResponse.value = await findKindergartenPaidAmount(searchParamResponse);
            items.value = pageResponse.value.content;
            items.value.forEach((item) => {
              let kindergartenPaidAmount: KindergartenPaidAmount = {
                id: null,
                paidDate: null,
                paidAmount: 0,
                kindergartenCalculationId: item.id,
                paymentNumber: "",
              }
              paidAmountForm[item.id] = reactive({
                showForm: false,
                loading: false,
                valueId: null,
                data: kindergartenPaidAmount
              });
            });
            fullPaidAmountForm.isLoading = false;
          } catch (error) {
            console.error('Ошибка при получении запроса:', error);
          }
        }

        const downloadFactPaymentReport = async () => {
          try {
            fullPaidAmountForm.isLoading = true;
            const searchParamResponse = searchParamSerializer();
            await getGeneratedFactPaymentReport(searchParamResponse);
            fullPaidAmountForm.isLoading = false;
          } catch (error) {
            console.error(error);
          }
        }

        const handleSubmit = async (data: KindergartenPaidAmount) => {
          paidAmountForm[data.kindergartenCalculationId].loading = true;
          if (data.paidDate !== null && data.paidAmount > 0 && data.kindergartenCalculationId != null) {
            paidAmountForm[data.kindergartenCalculationId].valueId = data.kindergartenCalculationId;
            let addedPaidAmount: KindergartenPaidAmount = await addKindergartenPaidAmount(data);
            let index = items.value !== undefined ? items.value.findIndex((item) => item.id === addedPaidAmount.kindergartenCalculationId) : -1;
            if (index !== -1 && items.value && items.value[index] !== undefined) {
              let updatedValue: KindergartenCalculationReport = items.value[index];
              updatedValue.totalPaidAmount = (updatedValue.totalPaidAmount == null ? 0 : updatedValue.totalPaidAmount) + addedPaidAmount.paidAmount;
              updatedValue.totalReminderAmount = parseFloat(updatedValue.totalSum) - (updatedValue.totalPaidAmount == null ? 0 : updatedValue.totalPaidAmount);
              updatedValue.kindergartenPaidAmounts?.push(addedPaidAmount);
              items.value[index] = updatedValue;
            }
            setTimeout(() => {
              paidAmountForm[data.kindergartenCalculationId].valueId = null;
            }, 600);
            paidAmountForm[data.kindergartenCalculationId].loading = true;
            closePaidForm(data.kindergartenCalculationId);
          }
        };

        const closePaidForm = (kindergartenCalculationId: number) => {
          paidAmountForm[kindergartenCalculationId] = reactive({
            showForm: false,
            loading: false,
            valueId: null,
            data: {
              id: null,
              paidDate: null,
              paidAmount: 0,
              kindergartenCalculationId: kindergartenCalculationId,
              paymentNumber: "",
            }
          });
        }

        const showPaidForm = (kindergartenCalculationId: number) => {
          paidAmountForm[kindergartenCalculationId].showForm = true;
        }

        const formatDate = (dateStr: string | null) => {
          if (dateStr == null || dateStr === '') {
            return '';
          }
          const date = new Date(dateStr);
          return new Intl.DateTimeFormat('ru-RU').format(date);
        }

        const showFullPaidModel = () => {
          fullPaidAmountForm.isShowModel = true;
        }

        const closeFullPaidModel = () => {
          fullPaidAmountForm.isShowModel = false;
          fullPaidAmountForm.isLoading = false;
        }

        const submitSetFullPaidAmount = async () => {
          fullPaidAmountForm.isLoading = true;
          const searchParamResponse = searchParamSerializer(true);
          const responseStatus = await addFullKindergartenPaidAmount(searchParamResponse, fullPaidAmountForm.paidDate);
          if (responseStatus == 200) {
            fullPaidAmountForm.paidDate = new Date();
            await fetchKindergartenFactPayment(true);
            closeFullPaidModel();
          }

        }

        const handleFileUpload = (event: any) => {
          uploadedFile.value = event.target.files[0];
        }

        const handleUploadSubmit = () => {
          try {
            if (uploadedFile.value) {
              isLoading.value = true;
              const formData = new FormData();
              formData.append('file', uploadedFile.value);
              uploadKindergartenPaidAmountXlsx(formData).then(() => {
                isLoading.value = false;
                window.location.reload();
              }).catch((error) => {
                if (error.status === 400) {
                  ElMessage({
                    message: error.response.data,
                    type: 'error',
                    duration: 0,
                    showClose: true,
                  });
                }
                isLoading.value = false;
              })
            }
          } catch(error) {
            isLoading.value = false;
            console.error(error);
          }
        }

        watch(currentPage, (newPage) => {
          searchParam.page = newPage;
          fetchKindergartenFactPayment()
        });

        return {
          currentPage,
          page,
          pageResponse,
          searchParam,
          kato,
          katoList,
          isLoading,
          items,
          paidAmountForm,
          fullPaidAmountForm,
          showUploadModal,
          handleFileUpload,
          formattedKatoLabel,
          clearSearchParam,
          fetchKindergartenFactPayment,
          handleSubmit,
          closePaidForm,
          showPaidForm,
          formatDate,
          showFullPaidModel,
          closeFullPaidModel,
          submitSetFullPaidAmount,
          downloadFactPaymentReport,
          handleUploadSubmit,
        };
      }
    }
);
</script>

<style scoped>

.success {
  background-color: green !important;
}

.default {
  transition: background-color 1s cubic-bezier(0, 1, 1, 0);
}

.open-modal-btn {
  display: block;
  margin: 20px auto;
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-modal-btn:hover {
  background-color: #45a049;
}

.modal {
  display: block;
  position: fixed;
  z-index: 5;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h4 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit-btn {
  width: 100%;
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.submit-btn:hover {
  background-color: #45a049;
}

.close-modal-btn {
  margin-top: 10px;
  width: 100%;
  padding: 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.close-modal-btn:hover {
  background-color: #e31b0c;
}
</style>